if (!customElements.get('mallow-toasting-upsell')) {
  customElements.define('mallow-toasting-upsell', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.labels = JSON.parse(this.querySelector('[data-ts-labels]').textContent);
      this.button = this.querySelector('.ts-upsell__add');
      this.status = this.querySelector('.ts-upsell__status');
      this.button.addEventListener('click', () => this.addStick());
    }
    async addStick() {
      if (this.busy || this.button.disabled) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.labels.adding;
      this.status.hidden = true;
      let unavailable = false;
      let confirmedAdded = false;
      try {
        if (typeof window.MallowCart?.afterAdd !== 'function') throw new Error(this.labels.checkError);
        const check = await fetch(this.dataset.productUrl, { cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!check.ok) throw new Error(this.labels.checkError);
        const product = await check.json();
        const variant = product.variants.find(item => String(item.id) === this.dataset.variantId);
        if (!variant?.available || product.requires_selling_plan) {
          unavailable = true;
          throw new Error(this.labels.unavailable);
        }
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(this.dataset.variantId), quantity: 1, sections: ['cart-drawer'], sections_url: window.location.pathname })
        });
        if (!response.ok) throw new Error(this.labels.error);
        const added = await response.json();
        confirmedAdded = true;
        await window.MallowCart.afterAdd(added, { trigger: this.button });
        this.classList.add('is-added');
        this.button.textContent = this.labels.added;
        this.showStatus(this.labels.addedMessage);
      } catch (error) {
        this.showStatus(confirmedAdded ? this.labels.refreshError : error.message || this.labels.error);
        this.button.textContent = unavailable ? this.labels.unavailable : this.labels.add;
      } finally {
        this.button.removeAttribute('aria-busy');
        if (this.isConnected && !unavailable) {
          setTimeout(() => {
            this.button.disabled = false;
            this.button.textContent = this.labels.add;
            this.classList.remove('is-added');
            this.busy = false;
          }, confirmedAdded ? 2500 : 0);
        } else {
          this.busy = false;
        }
      }
    }
    showStatus(message) {
      this.status.textContent = message;
      this.status.hidden = false;
    }
  });
}
